import { memo } from 'react'

import { Icon, Text } from 'common-components'
import TextWithIconTooltip from 'common-components/TextWithIconTooltip'
import TripleStarsIcon from 'assets/svgr-icons/TripleStars.svg'
import { TGender } from 'types/text-to-speech'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import * as Styled from './styled'
import { IProps } from './types'
import { userSelectors } from 'store/features/user/selectors'
import { useSelector } from 'react-redux'
import CrownIcon from 'assets/svgr-icons/Crown.svg'

export const TTS_SPEAKER_GENDER_MAP = {
  MALE: translate(T.MALE),
  FEMALE: translate(T.FEMALE)
}

export const getTtsSpeakerGenderLabel = (
  gender: TGender | null
): string | null => {
  if (!gender) {
    return null
  }
  return TTS_SPEAKER_GENDER_MAP[gender]
}

const SpeakerItemTextContent: React.FC<IProps> = props => {
  const {
    isActive,
    isHeader,
    displayName = translate(T.VOICE),
    gender,
    hasEmotion,
    isPremium
  } = props

  const isFreeUser = useSelector(userSelectors.isFreeUser)
  const isPremiumBadgeVisible = isPremium && isFreeUser

  return (
    <Styled.TextContentWrapper>
      {displayName && (
        <Styled.NameWrapper>
          <Text
            color={isActive ? 'secondaryDark' : 'secondarySemiDark'}
            type="h2"
            lineHeight="17px"
          >
            {displayName}
          </Text>
          {isPremiumBadgeVisible ? (
            <Icon
              icon={<CrownIcon />}
              size="small"
              color={isHeader ? 'secondarySemiDark' : 'goldDark'}
            />
          ) : (
            hasEmotion && (
              <TextWithIconTooltip
                tooltipText={
                  isHeader ? '' : translate(T.SPEAKER_TONE_TOOLTIP_TEXT)
                }
                tooltipPosition="top"
                iconProps={{
                  icon: <TripleStarsIcon />,
                  size: 'small',
                  color: isHeader ? 'secondarySemiDark' : 'goldDark'
                }}
              />
            )
          )}
        </Styled.NameWrapper>
      )}
      {!isHeader && gender && (
        <Text color="secondary" type="p" lineHeight="12px">
          {getTtsSpeakerGenderLabel(gender)}
        </Text>
      )}
    </Styled.TextContentWrapper>
  )
}

export default memo(SpeakerItemTextContent)
